import { axios, BaseApiUrl } from '../axios_config';

// 列表
export const getSignList = params => {
    return axios.post(`${BaseApiUrl}/TFMobile/GetTFAddServicesList`, { ...params }).then(res => res.data)
}

// 明细
export const getDeliveryNo = params => {
    return axios.get(`${BaseApiUrl}/TFMobile/GetAddServicesByID`, { params }).then(res => res.data);
}

// 签收
export const submitSignFor = params => {
    return axios.post(`${BaseApiUrl}/TFMobile/CompleteServices`, { ...params }).then(res => res.data);
}

